import React, { useEffect,  useState, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from "../FindModuleById";
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from "material-react-table";
import { Tooltip, IconButton, MenuItem } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import Swal from "sweetalert2";
import { loader_image } from "../_components/Imagepath";
import PropTypes from "prop-types";import $ from "jquery";
import Select from "react-select";

import { formatDistanceToNow } from 'date-fns';
const RawMaterialPricing = () => {
  // layout
  const [menu, setMenu] = useState(false);
  const toggleMobileMenu = () => setMenu((m) => !m);
  const [supplierName, setSupplierName] = useState([]);
  // Refs for top scrollbar
    const topScrollRef = useRef(null);
    const tableContainerRef = useRef(null);
  // permissions
  const [permission, setPermission] = useState({});
  const [overview, setOverview] = useState({});
  useEffect(() => {
    setPermission(FindModuleById(191));
  }, []);
   let season_id = localStorage.getItem("season_id");

  // filters form (top section)
  const [formData, setFormData] = useState({'season_id':season_id, supplier: "", start_date: "", end_date: "" });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((s) => ({ ...s, [name]: value }));
  };

  // table state
  const [data, setData] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [pagination, setPagination] = useState(() => {
    const saved = localStorage.getItem("tablePagination");
    return saved ? JSON.parse(saved) : { pageIndex: 0, pageSize: 10 };
  });
  const [sorting, setSorting] = useState(() => {
    const saved = localStorage.getItem("tableSorting");
    return saved ? JSON.parse(saved) : [];
  });
  const [columnFilters, setColumnFilters] = useState(() => {
    const saved = localStorage.getItem("tableColumnFilters");
    return saved ? JSON.parse(saved) : [];
  });
  const [globalFilter, setGlobalFilter] = useState("");

 


  useEffect(() => {
    localStorage.setItem("tablePagination", JSON.stringify(pagination));
  }, [pagination]);
  useEffect(() => {
    localStorage.setItem("tableSorting", JSON.stringify(sorting));
  }, [sorting]);
  useEffect(() => {
    localStorage.setItem("tableColumnFilters", JSON.stringify(columnFilters));
  }, [columnFilters]);

  // ui state
//  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);

  // fetch: server-side pagination/sorting/filtering
  const fetchProductionsOutputData = useCallback(async () => {
   // setIsLoading(true);
    setIsError(false);
    try {
      const response = await axios.post(
        "/raw-materials/listing-pagination",
        formData,
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          params: {
            page: pagination.pageIndex + 1,
            pageSize: pagination.pageSize,
            filters: columnFilters,
            sorting: sorting.map(({ id, desc }) => ({ column: id, order: desc ? "desc" : "asc" })),
            search: globalFilter,
          },
        }
      );

      // Backend shape per your controller
      const rows = response?.data?.data?.supply_chain_headers || [];
      const total = response?.data?.data?.totalRowCount || 0;
      setData(rows);
      setTotalRowCount(total);
    } catch (err) {
      console.error("Error fetching data", err);
      setIsError(true);
    } finally {
      //setIsLoading(false);
    }
  }, [pagination, sorting, columnFilters, globalFilter, formData]);

  useEffect(() => {
    setIsRefetching(true);
    
     axios.post("/raw-materials/listing-overview", formData, { headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      }
    ) .then((response) => {
      if (response.data.code === 200) {
       
        setOverview(response.data.data.overview)
        console.log(overview);
        
      } else {
        console.log("API response is not an array");
      }
    }).catch((error) => {
      console.log(error);
    });

     axios.post("/suppliers-trader/listing", {}, { headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      }
    ) .then((response) => {
      if (response.data.code === 200) {
        let suppliers = response.data.data.suppliers;
        let supplierslist = suppliers.map((cat, index) => ({
          label: cat.name,
          value: cat.id,
          key: `categories-${index}`,
        }));
        setSupplierName(supplierslist);
      } else {
        console.log("API response is not an array");
      }
    }).catch((error) => {
      console.log(error);
    });
    //fetchProductionsOutputData().finally(() => setIsRefetching(false));
  }, []);
// Fetch data whenever filters, pagination, or sorting changes
  // useEffect(() => {
  //   setIsRefetching(true);
  //   fetchProductionsOutputData().finally(() => setIsRefetching(false));
  // }, [fetchProductionsOutputData]);

  //   useEffect(() => {
      
  //   fetchProductionsOutputData(); // initial fetch when component mounts

  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "visible") {
  //       fetchProductionsOutputData(); // refetch when tab becomes visible again
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   // cleanup
  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, []);
 // Fetch data whenever filters, pagination, or sorting changes
  useEffect(() => {
    setIsRefetching(true);
    fetchProductionsOutputData().finally(() => setIsRefetching(false));

    // Also refetch when tab becomes visible again
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        fetchProductionsOutputData();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // cleanup
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [fetchProductionsOutputData]);
  const refetch = () => fetchProductionsOutputData();
  // ✅ Define row.original PropTypes
const rowOriginalShapemain = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  lot_number: PropTypes.string.isRequired,
  location_name: PropTypes.shape({
    title: PropTypes.string,
  }),
  date_time: PropTypes.string.isRequired,
  supplier_name: PropTypes.shape({
    name: PropTypes.string,
  }),
  plate_number: PropTypes.string,
  net_weight: PropTypes.number.isRequired,
  palletesation: PropTypes.arrayOf(
    PropTypes.shape({
      used: PropTypes.number.isRequired,
      type: PropTypes.number.isRequired,
      net_weight: PropTypes.number.isRequired,
    })
  ),
  created_at: PropTypes.string.isRequired,
  createdby: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
  updated_at: PropTypes.string.isRequired,
  updatedby: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
});
// ✅ Define row PropTypes
const rowShapemain = PropTypes.shape({
  original: rowOriginalShapemain.isRequired,
});
  
  // ✅ Lot Number Cell Component
const LotNumberCell = ({ row }) => (
  <a href={`/raw-material-pricing-edit/${row.original.id}`} className="">
    {row.original.lot_number}
  </a>
);
LotNumberCell.propTypes = {
  row: rowShapemain.isRequired,
};
// ✅ Weight Difference Cell Component
const WeightDifferenceCell = ({ row }) => {
  const totalDecay = row.original.palletesation || [];
  const totalNetWeight = totalDecay
    .filter((item) => item.used === 1)
    .reduce((sum, item) => sum + (item.net_weight || 0), 0);

  const weightDifference = row.original.net_weight - totalNetWeight;

  return <span>{weightDifference.toFixed(2)} (KG)</span>;
};
WeightDifferenceCell.propTypes = {
  row: rowShapemain.isRequired,
};
// ✅ Decay Net Weight Cell Component
const DecayNetWeightCell = ({ row }) => {
  const totalDecay = row.original.palletesation || [];
  const totalNetWeight = totalDecay
    .filter((item) => item.used === 1 && item.type === 1)
    .reduce((sum, item) => sum + (item.net_weight || 0), 0);

  return <span>{totalNetWeight.toFixed(2)} (KG)</span>;
};
DecayNetWeightCell.propTypes = {
  row: rowShapemain.isRequired,
};
  // columns (align with your earlier code/keys)
 const columns = [
  {
      header: 'Lot Number',
      // accessorFn: (row) => row.lot_number,
      accessorKey: 'lot_number',
      Cell: LotNumberCell,
    },
  
  {
       accessorKey: 'supplier_name',
       header: 'Supplier',
     },
       {
         header: "Price",
         accessorFn: (row) => parseFloat(row.price) +
           `${row.raw_currency ? row.raw_currency.symbol : ""}`,
       },
       {
         header: "Decay Price",
         accessorFn: (row) =>
           parseFloat(row.decay_price) +
           `${row.raw_currency ? row.raw_currency.symbol : ""}`,
       },
       {
         accessorKey: "driver_name",
         header: "Driver Name",
       },
       {
         accessorKey: "plate_number",
         header: "Plate Number",
       },
       {
         header: "Transport Cost",
         accessorFn: (row) =>
           parseFloat(row.transport_cost).toFixed(2) +
           `${row.raw_currency ? row.raw_currency.symbol : ""}`,
       },
       {
         header: "Workers Cost",
         accessorFn: (row) =>
           parseFloat(row.workers_cost).toFixed(2) +
           `${row.raw_currency ? row.raw_currency.symbol : ""}`,
       },
       {
         accessorKey: "shift_date",
         header: "Shift Date",
       },
     
        {
       accessorKey: 'former_name',
       header: 'Farm',
     },
     {
         header: "Total Net Weight",
         accessorFn: (row) => `${row.raw_material_net_weight.toFixed(2)} (KG)`,
       },
       
      
       {
         accessorKey: "date_time",
         header: "Date Time",
       },
       {
         accessorKey: 'location_name',
         header: 'Location',
       },
       {
         header: "BL Gross Weight",
         accessorFn: (row) => `${row.gross_weight.toFixed(2)} (KG)`,
       },
       {
         header: "BL Net Weight",
         accessorFn: (row) => `${row.net_weight.toFixed(2)} (KG)`,
       },
       {
         header: "Decay Net Weight",
         accessorFn: (row) => `${row.raw_material_decay_net_weight.toFixed(2)} (KG)`,
       },
     
       {
         header: "Rebate",
         accessorFn: (row) => row.rebate + "%",
       },
     
       {
         header: "Amount",
         accessorFn: (row) => `${row.total_amount.toFixed(2)} (KG)`,
       },
       {
         header: "Created By",
         accessorFn: (row) =>
           `${row.createdby ? row.createdby.first_name + " " + row.createdby.last_name : ""}`,
       },
       {
         header: 'Created At',
         accessorFn: (row) =>
           formatDistanceToNow(new Date(row.created_at), { addSuffix: true }),
       },
       {
         header: "Updated By",
         accessorFn: (row) =>
           `${row.updatedby ? row.updatedby.first_name + " " + row.updatedby.last_name : ""}`,
       },
       {
         header: 'Updated At',
         accessorFn: (row) =>
           formatDistanceToNow(new Date(row.updated_at), { addSuffix: true }),
       },
 ];

  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/raw-materials/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/raw-materials";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }

  const viewItem = (id) => {
    window.location.href = "/raw-material-pricing-view/" + id;
  };

 
  // download excel
  const objectToQueryString = (obj) =>
    Object.keys(obj)
      .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
      .join("&");
  const downloadExcel = () => {
    const queryString = objectToQueryString(formData);
    window.open(`${base_url}/raw-materials-pricing/listing-excel-open?${queryString}`, "_blank");
  };

  // Tabs (optional group-by sections)
  const [dataGroupByShiftDateLocation, setDataGroupByShiftDateLocation] = useState([]);
  const [dataGroupCustomer, setDataGroupCustomer] = useState([]);

  const fetchGroupByShiftDateLocation = async () => {
    try {
      const response = await axios.post("/raw-materials/fetchGroupByShiftDateLocation", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });
      if (response.data.code === 200) setDataGroupByShiftDateLocation(response.data.data.materials_groupby || []);
    } catch (e) {
      console.error(e);
    }
  };

  const listingGroupByCustomer = async () => {
    try {
      const response = await axios.post("/raw-materials/listingGroupByCustomer", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });
      if (response.data.code === 200) setDataGroupCustomer(response.data.data.materials_customer || []);
    } catch (e) {
      console.error(e);
    }
  };
 

  

// ✅ Define row.original PropTypes
const rowOriginalShape2 = PropTypes.shape({
  shift_date: PropTypes.string.isRequired,
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  location_name: PropTypes.shape({
    title: PropTypes.string,
  }),
  sum_net_weight: PropTypes.number.isRequired,
  net_weight_decay: PropTypes.number.isRequired,
  total_raw: PropTypes.number.isRequired,
});

// ✅ Define row PropTypes
const rowShape2 = PropTypes.shape({
  original: rowOriginalShape2.isRequired,
});


// ✅ Location Cell Component
const shiftDate = ({ row }) => (
  <a href={`/raw-material-pricing-groupby/${row.original.shift_date}_${row.original.location}`} className="">
    {row.original.shift_date ? row.original.shift_date : ''}
  </a>
);
shiftDate.propTypes = {
  row: rowShape2.isRequired,
};
// ✅ Location Cell Component
const LocationCell2 = ({ row }) => (
  <a href={`/raw-material-pricing-groupby/${row.original.shift_date}_${row.original.location}`} className="">
    {row.original.location_name ? row.original.location_name.title : ''}
  </a>
);
LocationCell2.propTypes = {
  row: rowShape2.isRequired,
};


const rowOriginalShape = PropTypes.shape({
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // <--- add this
  location_name: PropTypes.shape({
    title: PropTypes.string,   // <--- add title here
  }).isRequired,
  pallet_type_title: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
  }),
  num_pallets: PropTypes.number,   // optional, not always present
  net_weight_total: PropTypes.number,
  sum_net_weight: PropTypes.number,
  net_weight_decay: PropTypes.number,
  total_raw: PropTypes.number,
});

// ✅ Define row PropTypes
const rowShape = PropTypes.shape({
  original: rowOriginalShape.isRequired,
});

// ✅ Location Cell Component
const LocationCell = ({ row }) => (
  <a href={`/raw-materials-groupbylocation/${row.original.location}`} className="">
    {row.original.location_name ? row.original.location_name.title : ''}
  </a>
);
LocationCell.propTypes = {
  row: rowShape.isRequired,
};
const AverageBuyingPriceCell = ({ row }) => {
  if (!row || !row.original) return "0dh";
  const block = row.original.total_net_weight_price || 0;
  const weight = row.original.sum_net_weight || 0;

  return weight === 0 ? "0dh" : `${(block / weight).toFixed(2)}dh`;
};

AverageBuyingPriceCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      total_net_weight_price: PropTypes.number,
      sum_net_weight: PropTypes.number,
    }),
  }),
};
  const columnsGroupByShiftDateLocation = [
    {
    header: 'Shift Date',
    accessorFn: (row) => row.shift_date,
    Cell: shiftDate,
  },
  {
    header: 'Location',
    accessorFn: (row) => (row.location_name ? row.location_name.title : ''),
    Cell: LocationCell2,
  },
  {
    header: 'Net Weight',
    accessorFn: (row) => `${row.sum_net_weight.toFixed(2)} (KG)`,
  },
  
 {
    header: "Average Buying Price",
    accessorFn: (row) => {
      const block = row.total_net_weight_price || 0;
      const weight = row.sum_net_weight || 0;
      return weight === 0 ? "0dh" : `${(block / weight).toFixed(2)}dh`;
    },
    Cell: AverageBuyingPriceCell,
  },
  
  {
    header: 'No of Receptions',
    accessorFn: (row) => `${row.total_raw}`,
  },
  ];

    const SupplierCell = ({ row }) => {
      if (!row || !row.original) return null;
      return (
        <a
          href={`/raw-material-pricing-supplier-groupby/${row.original.supplier}`}
          className=""
        >
          {row.original.supplier_name ? row.original.supplier_name.name : ""}
        </a>
      );
    };
    
    SupplierCell.propTypes = {
      row: PropTypes.shape({
        original: PropTypes.shape({
          supplier: PropTypes.string,
          supplier_name: PropTypes.shape({
            name: PropTypes.string,
          }),
        }),
      }),
    };
     const AverageBuyingPriceCell2 = ({ row }) => {
          if (!row || !row.original) return "0dh";
          const total_price = row.original.total_price || 0;
          const weight = row.original.sum_net_weight || 0;
        
          return weight === 0 ? "0dh" : `${(total_price / weight).toFixed(2)}dh`;
        };
        
        AverageBuyingPriceCell2.propTypes = {
          row: PropTypes.shape({
            original: PropTypes.shape({
              total_price: PropTypes.number,
              sum_net_weight: PropTypes.number,
            }),
          }),
        };
    const columnsGroupByCustomer = [
    {
        header: "Supplier",
        accessorFn: (row) => `${row.supplier_name ? row.supplier_name.name : ""}`,
        Cell: SupplierCell,
      },
      {
        header: "Location",
        accessorFn: (row) => `${row.location_name ? row.location_name.title : ""}`,
      },
      {
        header: "Net Weight",
        accessorFn: (row) => `${row.sum_net_weight.toFixed(2)} (KG)`,
      },
      {
        header: "Average Buying Price",
        accessorFn: (row) => {
          const total_price = row.total_price || 0;
          const weight = row.sum_net_weight || 0;
          return weight === 0 ? "0dh" : `${(total_price / weight).toFixed(2)}dh`;
        },
        Cell: AverageBuyingPriceCell2,
      },
      {
        header: "Receptions",
        accessorFn: (row) => `${row.total_raw}`,
      },
];
  const printRawmaterial = (rawmaterial) => {
     let id = rawmaterial.id;
   let season_id = localStorage.getItem("season_id");

    $("#raw-material-"+id+"").removeClass('loader-hide');
    $("#raw-material-"+id+"").addClass('loader-show');
   
    axios.get(`/raw-materials/pdf-raw-material/${season_id+'-'+id}`, {
       responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
   }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        // let file_name = 'raw material.pdf';
        let lot_number = rawmaterial.lot_number;
        let file_name = lot_number+'.pdf';
        link.download = file_name;
        
        link.click();

        $("#raw-material-"+id+"").addClass('loader-hide');
        $("#raw-material-"+id+"").removeClass('loader-show');

    })
    .catch(error => {
        console.error('Error downloading PDF:', error);
    });
  }


  const printRawmaterialLotInfo = (rawmaterial) => {
     let id = rawmaterial.id;
    let season_id = localStorage.getItem("season_id");
    $("#raw-info-"+id+"").removeClass('loader-hide');
    $("#raw-info-"+id+"").addClass('loader-show');
    axios.get(`/raw-materials/pdf-raw-material-lot-info/${season_id+'-'+id}`, {
       responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
   }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        // let file_name = 'Raw material Lot Info.pdf';
        // link.download = file_name;
        let lot_number = rawmaterial.lot_number;
        let file_name = lot_number+' Raw material Lot Info.pdf';
         link.download = file_name;
        link.click();
        $("#raw-info-"+id+"").addClass('loader-hide');
        $("#raw-info-"+id+"").removeClass('loader-show');
    })
    .catch(error => {
        console.error('Error downloading PDF:', error);
    });
  }
   const handleSelectChangeCustomer = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, supplier: selectedOption.value }); 
  };
  
  console.log(overview);
  // Sync scrollbars for main table
  useEffect(() => {
    const syncScrollbars = () => {
      const tableContainer = document.querySelector('.production-output-listing .MuiTableContainer-root');
      const topScroll = topScrollRef.current;
      const topScrollContent = topScroll?.querySelector('.top-scroll-content');

      if (tableContainer && topScroll && topScrollContent) {
        topScrollContent.style.width = `${tableContainer.scrollWidth}px`;
        
        const handleTopScroll = () => {
          tableContainer.scrollLeft = topScroll.scrollLeft;
        };
        
        const handleTableScroll = () => {
          topScroll.scrollLeft = tableContainer.scrollLeft;
        };

        topScroll.addEventListener('scroll', handleTopScroll);
        tableContainer.addEventListener('scroll', handleTableScroll);

        return () => {
          topScroll.removeEventListener('scroll', handleTopScroll);
          tableContainer.removeEventListener('scroll', handleTableScroll);
        };
      }
    };

    const timer = setTimeout(syncScrollbars, 100);
    return () => clearTimeout(timer);
  }, [data]);
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={toggleMobileMenu} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Raw Material Pricing</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Raw Material Pricing Listing</li>
                  </ul>
                </div>
                <div className="col-auto">
                 
                  &nbsp;&nbsp;
                  {permission && permission.list == 1 && (
                    <button className="btn btn-primary" onClick={downloadExcel}>
                      <i className="fa fa-file-excel-o"></i> <i className="fa fa-download"></i>
                      <img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image} alt="loader" />
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Filters */}
            <div id="filter_inputs" className="card filter-card2">
              <div className="card-body p-10">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Select Supplier:</label>
                    
                        <Select
                          options={supplierName}
                          name="supplier"
                          value={supplierName.find(option => option.value === formData.supplier) || null} // Ensure it selects the correct option
                          onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                          />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Start Date:</label>
                        <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>End Date:</label>
                        <input type="date" name="end_date" className="form-control" value={formData.end_date} onChange={handleChange} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="pt-4 mt-2">
                        <button type="button" className="btn btn-primary" onClick={refetch}>
                          Filter
                        </button>
                        &nbsp;&nbsp;
                        <a href="/raw-material-pricing" className="btn btn-primary me-1">
                          <i className="fa fa-times"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
                <div className="row">
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Net Weight </div>
                          <div className="dash-counts">
                            <p>{overview?.sum_net_weight_total ? overview.sum_net_weight_total.toFixed(2) : "0.00"} KG</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>

                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Average Buying </div>
                          <div className="dash-counts">
                            <p>{(overview.total_price/overview.total_bl_net_weight).toFixed(2)} KG</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Reception </div>
                          <div className="dash-counts">
                            <p>{overview?.row_count ? overview.row_count : "0"} </p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                
                </div>
            {/* Tabs */}
            <div className="row">
              <div className="col-sm-12">
                <section className="comp-section">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card bg-white">
                        {permission && permission.list == 1 && (
                          <div className="card-body">
                            <ul className="nav nav-tabs nav-tabs-bottom">
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-groupby" data-bs-toggle="tab" onClick={fetchGroupByShiftDateLocation}>
                                  Raw Material Group by Shift date and Location
                                </a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-pallets" data-bs-toggle="tab" onClick={listingGroupByCustomer}>
                                  Raw Material Group By Supplier
                                </a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link active" href="#listing-all" data-bs-toggle="tab" onClick={refetch}>
                                  Raw materials
                                </a>
                              </li>
                            </ul>

                            <div className="tab-content">
                              {/* Group By Shift Date */}
                              <div className="tab-pane" id="listing-groupby">
                                <div className="row" id="listing-followup-groupby">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable columns={columnsGroupByShiftDateLocation} data={dataGroupByShiftDateLocation} enableColumnOrdering enablePinning />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Group By Pallet Type */}
                              <div className="tab-pane" id="listing-pallets">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable columns={columnsGroupByCustomer} data={dataGroupCustomer} enableColumnOrdering enablePinning />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Productions Output (main) */}
                              <div className="tab-pane show active" id="listing-all">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                         <div 
                                          ref={topScrollRef} 
                                          className="top-scrollbar"
                                          style={{
                                            overflowX: 'auto',
                                            overflowY: 'hidden',
                                            marginBottom: '10px',
                                            height: '20px'
                                          }}
                                        >
                                          <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                        </div>
                                        <div className="table-responsive production-output-listing" ref={tableContainerRef}>
                                          <MaterialReactTable
                                            columns={columns}
                                            data={data}
                                            manualFiltering
                                            manualPagination
                                            manualSorting
                                            muiToolbarAlertBannerProps={
                                              isError ? { color: "error", children: "Error loading data" } : undefined
                                            }
                                            onColumnFiltersChange={setColumnFilters}
                                            onGlobalFilterChange={setGlobalFilter}
                                            onSortingChange={setSorting}
                                            onPaginationChange={setPagination}
                                            renderTopToolbarCustomActions={() => (
                                              <Tooltip arrow title="Refresh Data">
                                                <IconButton onClick={refetch}>
                                                  <RefreshIcon />
                                                </IconButton>
                                              </Tooltip>
                                            )}
                                            rowCount={totalRowCount}
                                            pageCount={Math.ceil(totalRowCount / pagination.pageSize) || 0}
                                            enableDebug={true}
                                            state={{
                                              columnFilters,
                                              globalFilter,
                                              //isLoading,
                                              pagination,
                                              showAlertBanner: isError,
                                              showProgressBars: isRefetching,
                                              sorting,
                                            }}
                                            enableRowActions
                                            renderRowActionMenuItems={({ row }) => [
                                               permission?.list == 1 && (
                                              <MenuItem key="delete" onClick={() => printRawmaterial(row.original)}>
                                                Print Raw Material <img  id={`raw-material-${row.original.id}`} className="loader-image loader-hide" src={loader_image}/> 
                                              </MenuItem>
                                              ),
                                              permission?.list == 1 && (
                                                    <MenuItem key="delete" onClick={() => printRawmaterialLotInfo(row.original)}>
                                                    Print LotInfo <img  id={`raw-info-${row.original.id}`} className="loader-image loader-hide" src={loader_image}/> 
                                                  </MenuItem>
                                              ),
                                              permission?.update == 1 && (
                                                <MenuItem key="edit" onClick={() => viewItem(row.original.id)}>
                                                  View
                                                </MenuItem>
                                              ),
                                              permission?.delete == 1 && (
                                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                  Delete
                                                </MenuItem>
                                              ),
                                            ]}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RawMaterialPricing;
